"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTypingEffect = exports.useTLDAnimation = exports.TypingEffect = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TypingEffect = require("./styles/TypingEffect");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const useTLDAnimation = ({
  tldList,
  loopDelay,
  showTLD
}) => {
  const [currentText, setCurrentText] = (0, _react.useState)('');
  const [currentIndex, setCurrentIndex] = (0, _react.useState)(0);
  (0, _react.useEffect)(() => {
    if (!showTLD) {
      setCurrentIndex(0);
      setCurrentText('');
    }
  }, [showTLD]);
  (0, _react.useEffect)(() => {
    if (showTLD && currentIndex < tldList.length) {
      const timeout = setTimeout(() => {
        setCurrentText(tldList[currentIndex]);
        setCurrentIndex(prevIndex => prevIndex + 1);
      }, loopDelay * 0.5 / tldList.length);
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, loopDelay, showTLD, tldList]);
  return currentText;
};
exports.useTLDAnimation = useTLDAnimation;
const useTypingEffect = ({
  text,
  delay,
  loops,
  loopDelay
}) => {
  const [currentLoops, setCurrentLoops] = (0, _react.useState)(1);
  const [currentText, setCurrentText] = (0, _react.useState)('');
  const [currentIndex, setCurrentIndex] = (0, _react.useState)(0);

  // This is for typing
  (0, _react.useEffect)(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setCurrentText(prevText => prevText + text[currentIndex]);
        setCurrentIndex(prevIndex => prevIndex + 1);
      }, delay);
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, delay, text]);

  // This is for looping
  (0, _react.useEffect)(() => {
    let loopTimeout;
    if (currentText.length === text.length && currentLoops < loops) {
      loopTimeout = setTimeout(() => {
        setCurrentText('');
        setCurrentIndex(0);
        setCurrentLoops(prevLoops => prevLoops + 1);
      }, loopDelay);
    }
    return () => {
      clearTimeout(loopTimeout);
    };
  }, [currentLoops, loops, loopDelay, text, currentText]);
  return currentText;
};
exports.useTypingEffect = useTypingEffect;
const TypingEffect = ({
  text,
  delay = 80,
  hasTypeIndicator = true,
  blinkingTypeIndicator = true,
  loops = 2,
  loopDelay = 2000,
  textClassName,
  tldTextClassName,
  tldList = []
}) => {
  const displayText = useTypingEffect({
    text,
    loops,
    delay,
    loopDelay
  });
  const isShowingFullText = displayText.length === text.length;
  const tldText = useTLDAnimation({
    tldList,
    loopDelay,
    showTLD: isShowingFullText
  });
  return /*#__PURE__*/_react.default.createElement(_TypingEffect.TypingEffectContainer, {
    centered: tldList.length > 0
  }, /*#__PURE__*/_react.default.createElement("p", {
    "data-testid": 'typing-effect-text',
    className: textClassName || 'typing-effect-text typing-effect-size'
  }, displayText, hasTypeIndicator && /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": 'typing-effect-type-indicator',
    className: (0, _classnames.default)({
      'typing-effect-blinking-type-indicator': blinkingTypeIndicator && isShowingFullText,
      'typing-effect-type-indicator': !blinkingTypeIndicator || !isShowingFullText
    })
  }), tldList.length > 0 && /*#__PURE__*/_react.default.createElement("span", {
    className: tldTextClassName || 'typing-effect-text typing-effect-tld'
  }, tldText)));
};
exports.TypingEffect = TypingEffect;
TypingEffect.propTypes = {
  text: _propTypes.default.string,
  textClassName: _propTypes.default.string,
  tldTextClassName: _propTypes.default.string,
  delay: _propTypes.default.number,
  loops: _propTypes.default.number,
  loopDelay: _propTypes.default.number,
  hasTypeIndicator: _propTypes.default.bool,
  blinkingTypeIndicator: _propTypes.default.bool,
  tldList: _propTypes.default.array
};